export default "__VITE_ASSET__DlIJhs6L__"